<template>
  <el-row
    v-loading="loading"
    class="padding_5px_top padding_10px_bottom"
  >
    <el-table
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column
        type="index"
        label="序号"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        min-width="10%"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="
                            downloadFile({
                                url: scope.row.targetFolder,
                                fileName: scope.row.title
                            })
                        "
          >{{ scope.row.title }}</el-button>
        </template></el-table-column>
      <el-table-column
        prop="author"
        label="作者"
        min-width="10%"
      ></el-table-column>
      <el-table-column
        prop="effectiveDate"
        label="发布日期"
        min-width="10%"
      >
        <template slot-scope="scope">
          {{ scope.row.effectiveDate | replaceTime }}
        </template>
      </el-table-column>
    </el-table>
    <el-col class="left_text_align padding_25px_top">
        <el-pagination class="left_text_align padding_25px_top"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50, 100,200]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="(pagination && pagination.count) || 0"
        v-if="pagination.count >= 10 ? true : false"
        >
        </el-pagination>
     </el-col>
  </el-row>
</template>

<script>
import { Message } from "element-ui";
import { getMethodology } from "../../api/suitability";

const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;
const fetchFile=componentsCommon.downloadUtils.fetchFile;
const downloadFtpFile=componentsCommon.apiCommon.downloadFtpFile;

export default {
    data() {
        return {
            loading: false,
            pagination: {
                skip: 0,
                limit: 10,
                count: 0
            },
            params: {
                sort: "effectiveDate",
                order: "desc",
                limit: 10,
                skip: 0,
                page: 1,
                type: 1
            },
            tableData: []
        };
    },
    filters: {
        replaceTime(value) {
            if (value != undefined && value != null && value != "") {
                return value.replace("00:00:00.0", "");
            } else {
                return "--";
            }
        }
    },
    methods: {
        methodology(params) {
            let self = this;
            self.loading = true;
            getMethodology(params)
                .then(response => {
                    let jsonData = response.data;
                    if (jsonData == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(jsonData, self)) {
                            //self.pagination = jsonData.pagination;
                            self.tableData = jsonData.data.methodology;
                        }
                    }
                })
                .catch(err => {
                    self.loading = false;
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.loading = false;
                });
        },
        handleSizeChange(val) {
            const self = this;
            self.params.limit = val;
            self.methodology(self.params);
            // self.params.order = "desc";
            // self.params.sort = "lastUpdate";
        },
        handleCurrentChange(val) {
            const self = this;
            self.params.page = val;
            self.params.skip = (val - 1) * self.params.limit;
            self.methodology(self.params);
            // self.params.order = "desc";
            // self.params.sort = "lastUpdate";
        },
        loadingData(val) {
            let self = this;
            self.params.type = val;
            self.methodology(self.params);
        },
        downloadFile(data) {
            let fileName = data.fileName + ".pdf";
            let fileType = "application/pdf;charset=utf-8";
            downloadFtpFile(data)
                .then(response => {
                    let data = response.data;
                    if (response.status == 200) {
                        fetchFile(data, fileType, fileName);
                    }
                    self.loading = false;
                })
                .catch(err => {
                    self.loading = false;
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.loading = false;
                });
        }
    }
};
</script>
